import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './viewer.css';

const textRenderer = ({ renderers, node }) => {
  if (!node.type) {
    const nodeKeys = Object.keys(node);
    const nodeMarks = nodeKeys.filter((key) => node[key] === true);
    if (!nodeMarks || nodeMarks.length === 0) return node.text;

    return nodeMarks.reduce(
      (children, mark, key) =>
        renderBlock({
          renderers,
          node: { type: mark },
          nodeAttributes: { children, key },
        }) || children,
      node.text
    );
  }
};

const renderBlock = ({ renderers, node, nodeAttributes }) => {
  let element;
  renderers.find(
    (renderer) => (element = renderer({ renderers, node, nodeAttributes }))
  );
  return element;
};

const renderBlocks = ({ renderers, nodes }) =>
  nodes
    .map((node, key) => {
      const children =
        renderBlocks({ renderers, nodes: node.children || [] }) || null;

      const element = renderBlock({
        renderers,
        node,
        nodeAttributes: { children, key },
      });
      return element;
    })
    .filter((e) => !!e);

const Viewer = ({ className, renderers, document }) => (
  <div className={cx(styles.viewer, className)}>
    {renderBlocks({
      renderers: [textRenderer, ...renderers],
      nodes: document,
    })}
  </div>
);

Viewer.propTypes = {
  className: PropTypes.string,
  renderers: PropTypes.arrayOf(PropTypes.func),
  document: PropTypes.array,
};

export { Viewer };
